<template>
  <transition name="toast">
    <div
      v-if="message"
      class="flash-message"
    >
      {{ message }}
    </div>
  </transition>
</template>
  
  <script>
  import { mapGetters } from "vuex";
  
  export default {
    computed: {
      ...mapGetters(["getFlashMessage"]),
      message() {
        return this.getFlashMessage;
      }
    }
  };
  </script>
  
  <style scoped>
  .flash-message {
    position: fixed;
    top: 20px;
    right: 20px;
    background: rgba(25, 149, 3, 0.7);
    color: #fff;
    padding: 12px 18px;
    border-radius: 10px;
    font-weight: 500;
    font-size: 15px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    z-index: 9999;
    line-height: 1.4;
    min-width: 220px;
    text-align: center;
    letter-spacing: 0.3px;
  }
  
  /* 🔥 Smooth slide + fade animation */
  .toast-enter-active,
  .toast-leave-active {
    transition: all 0.4s ease;
  }
  .toast-enter-from {
    opacity: 0;
    transform: translateY(-20px) translateX(100%);
  }
  .toast-leave-to {
    opacity: 0;
    transform: translateY(-20px) translateX(100%);
  }
  </style>
  